  File name: TimePicker.vue
  Program Description:
    - This component allows the user to enter a specific time value.
-->
<template>
  <v-container>
    <v-row>
      <v-menu
        v-model="openTimePicker"
        offset-y
        :close-on-click="true"
        :close-on-content-click="false"
      >
        <template v-slot:activator="menu">
          <v-text-field
            v-bind="menu.attrs"
            :append-icon="appendIcon"
            :value="timeResult || value"
            :dense="dense"
            :readonly="!disabled"
            :outlined="outlined"
            :solo="solo"
            :flat="flat"
            :label="label"
            :error-messages="errorMessages"
            :disabled="disabled"
            :clearable="clearable"
            @click:clear="clearTime()"
            @click:append="openTimePicker = !menu.value"
            v-on="menu.on"
          />
        </template>
        <v-card
          flat
          max-height="250px"
        >
          <v-container>
            <v-row>
              <!-- hours -->
              <v-col class="col-container">
                <v-row
                  ref="hoursTitle"
                  class="row-title"
                  justify="center"
                >
                  <h4>HOURS</h4>
                </v-row>
                <v-row
                  v-for="n in hours"
                  :key="n"
                  :ref="`hours${n}`"
                  :class="`${activeHour === n ? 'active-item ' : ''}menu-row`"
                  justify="center"
                  @click="activeHour = n, itemClick()"
                >
                  <span class="py-1">{{ `${n >= 10 ? '': '0'}${n}` }}</span>
                </v-row>
              </v-col>
              <!-- mins -->
              <v-col class="col-container">
                <v-row
                  ref="minsTitle"
                  class="row-title"
                  justify="center"
                >
                  <h4>MINUTES</h4>
                </v-row>
                <v-row
                  v-for="n in mins"
                  :key="n"
                  :ref="`mins${n-1}`"
                  :class="`${activeMins === (n-1) ? 'active-item ' : ''}menu-row`"
                  justify="center"
                  @click="activeMins = (n-1), itemClick()"
                >
                  <span class="py-1">{{ `${(n-1) >= 10 ? '': '0'}${n-1}` }}</span>
                </v-row>
              </v-col>
              <!-- am/pm -->
              <v-col class="col-container">
                <v-row
                  v-for="n in ['AM', 'PM']"
                  :key="n"
                  :class="`${activeAmPm === n ? 'active-item ' : ''}menu-row`"
                  justify="center"
                  @click="activeAmPm = n, itemClick()"
                >
                  <span class="py-1">{{ n }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-menu>
    </v-row>
  </v-container>
</template>

<script>

export default {
  props: {
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: Array,
      default: undefined
    },
    dense: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: 'mdi-calendar-clock'
    }
  },
  data: () => ({
    openTimePicker: false,
    hours: 12,
    mins: 60,
    activeHour: -1,
    activeMins: -1,
    activeAmPm: -1
  }),
  computed: {
    timeResult () {
      if (this.activeHour === -1 || this.activeMins === -1 || this.activeAmPm === -1) return ''
      return `${this.activeHour}:${this.activeMins >= 10 ? this.activeMins : `0${this.activeMins}`} ${this.activeAmPm}`
    }
  },
  methods: {
    // Returns the time result for every input
    itemClick () {
      this.$emit('input', this.timeResult)
    },
    // Clear the time value
    clearTime () {
      this.$refs.hoursTitle.scrollIntoView()
      this.$refs.minsTitle.scrollIntoView()
      this.activeHour = -1
      this.activeMins = -1
      this.activeAmPm = -1
      this.$emit('input', this.timeResult)
    }
  }
}
</script>

<style scoped>
.menu-row {
    cursor: pointer;
}
.menu-row:hover {
    background: rgba(0, 0, 0, 0.1);
}
.row-title {
    color: #272a68 !important;
}
.col-container {
    max-height:250px;
    overflow:auto;
}
.active-item {
    color: #272a68 !important;
    font-size: 32px;
    transition: 0.1s;
}
</style>
